module.exports = __webpack_public_path__ + "img/Bear-Creek-east.0b5e14cf.png";